import React, { useEffect } from "react";
import { useNavigate } from "react-router-dom";
import "../ListeFamille.css";

const ListeFamille = ({
  libelle,
  id,
  image,
  langue,
  libelle_ar,
  wcli,
  nav,
  code_fam,
  cumul_chiffre_famille,
  nbr_art,
}) => {
  const navigate = useNavigate();
  const uri = "https://gestpro.globalsystempro.com";
  const sour = image ? `${uri}${image}` : null;

  const handleClick = () => {
    const params = {
      state: {
        itemId: nav === "ArticleListeOracle" ? code_fam : id,
        langue: langue,
        wcli: wcli,
        libelle: langue === "F" || !libelle_ar ? libelle : libelle_ar,
      },
    };

    navigate(
      nav === "ArticleListeOracle"
        ? "/article-liste-oracle"
        : "/ArticlesParFamille",
      params
    );
  };

  return (
    <div className="famille-card">
      <div className="famille-content" onClick={handleClick}>
        {nav === "ArticleListeOracle" && (
          <>
            <div className="famille-stats-row">
              <span className="stats-label">Chiffre de Mois:</span>
              <span className="stats-value">
                {cumul_chiffre_famille ? cumul_chiffre_famille.toFixed(3) : 0}
              </span>
            </div>
            <div className="famille-stats-row">
              <span className="stats-label">Nbr Article:</span>
              <span className="stats-value">{nbr_art ? nbr_art : 0}</span>
            </div>
          </>
        )}

        {sour && (
          <img
            src={sour}
            alt={libelle}
            className="famille-image"
            onError={(e) => {
              e.target.style.display = "none";
            }}
          />
        )}
      </div>

      <div className="famille-title">
        {langue === "F" || !libelle_ar ? libelle : libelle_ar}
      </div>
    </div>
  );
};

export default React.memo(ListeFamille);
